// FirstUseDisclaimer.tsx
import React, { useState } from "react";
import { ModalLinkButton } from '../../Controls/Button/ModalLinkButton';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsAndConditions } from './TermsAndConditions';
import { CookiePolicy } from './CookiePolicy'; 
import "./css/FirstUseDisclaimer.css";

interface FirstUseDisclaimerProps {
    onAccept: () => void; // parent sets hasAcceptedPolicies = true
}

export const FirstUseDisclaimer: React.FC<FirstUseDisclaimerProps> = ({ onAccept }) => {
    const [checked, setChecked] = useState(false);

    return (
        <div className="disclaimer">
            <div className="disclaimer__overlay" />

            <div className="disclaimer__modal">
                <h1 className="disclaimer__title">Welcome to Skitterbook</h1>

                <p className="disclaimer__intro">
                    Before you begin, please review and acknowledge our key policies.
                    These documents explain how your data is handled, how cookies are used,
                    and the terms under which you may use the Skitterbook service.
                </p>

                <div className="disclaimer__links">
                    <p>
                        • <ModalLinkButton Title="Privacy Policy" modalTitle="Privacy Policy"><PrivacyPolicy /></ModalLinkButton>
                    </p>
                    <p>
                        • <ModalLinkButton Title="Terms and Conditions" modalTitle="Terms and Conditions"><TermsAndConditions /></ModalLinkButton>
                    </p>
                    <p>
                        • <ModalLinkButton Title="Cookie Policy" modalTitle="Cookie Policy"><CookiePolicy /></ModalLinkButton>
                    </p>
                </div>

                <label className="disclaimer__checkbox">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => setChecked(e.target.checked)}
                    />
                    <span>
                        I confirm that I have read and agree to the Privacy Policy, Cookie
                        Policy and Terms of Reference.
                    </span>
                </label>

                <button
                    className="disclaimer__button"
                    disabled={!checked}
                    onClick={onAccept}>
                    Continue to Skitterbook
                </button>
            </div>
        </div>
    );
};

export default FirstUseDisclaimer;
